import { attr, fk } from 'redux-orm'
import Base from './Base'

class Team extends Base {
  static get fields() {
    return {
      id: attr(),
      name: attr(),
      members: attr(),
      officeId: fk({to: 'office', as: 'office', relatedName: 'team'}),
    }
  }
}

Team.modelName = 'team'

export default Team;
